<template>
  <div id="nav">
    <b-navbar toggleable="lg" type="dark" variant="info" class="navbar-dark bg-dark">
      <b-navbar-brand href="./">類似スコア検索</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
         <li v-for="l in list" v-bind:key="l.id">
            <b-nav-item><router-link class="text-white px-3" :to="{ name: 'similarity', params: { id: l.id }}">{{ l.title }}</router-link></b-nav-item>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<style>
.navbar-default {
background-color: #000033;
border-color: #000033;
}
</style>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['list'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myheader.vue